import {
    ChangeDetectionStrategy,
    Component,
    contentChild,
    input,
} from '@angular/core';
import { QpxHeading } from '../../directives';
import { QpxHeaderLabel } from './header-label';

@Component({
    selector: 'qpx-header',
    imports: [QpxHeading],
    templateUrl: './header.html',
    styleUrl: './header.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'flex items-start justify-between',
    },
})
export class QpxHeader {
    //#region Inputs
    public readonly heading = input('');
    public readonly titleId = input.required<string>();
    //#endregion

    //#region Template references
    protected readonly projectedLabel = contentChild(QpxHeaderLabel);
    //#endregion
}
